<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';
import type { ArticleV1 } from '@ilteducation/content-registry-types';
import { useLocale } from '@/plugins/translation';
import RelatedContentPreview from './RelatedContentPreview.vue';

type Props = {
  relatedArticles: ArticleV1[] | null;
};

const props = defineProps<Props>();

const { t, l } = useLocale();

const emit = defineEmits<{
  (e: 'openArticle', id: string): void;
}>();

const onOpen = (id: string) => emit('openArticle', id);
</script>

<template>
  <div id="related-article">
    <div class="related-articles-message py-4 bg-surface">
      <p>
        {{ relatedArticles && relatedArticles.length > 0 ? t(l.film.articlesTooltip) : t(l.film.noRelatedArticles) }}
      </p>
    </div>
    <div v-if="relatedArticles !== null">
      <div v-for="(relatedArticle, index) in props.relatedArticles?.slice(0, 4)" :key="index">
        <RelatedContentPreview :related-article="relatedArticle" @openArticle="onOpen"> </RelatedContentPreview>
      </div>
    </div>
    <div v-else>
      <div v-for="index in 4" :key="index">
        <v-skeleton-loader type="table-heading, list-item-two-line"></v-skeleton-loader>
        <v-divider></v-divider>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.multi-line-truncate {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  height: calc(1.2em * 2);
  line-height: 1.2em;
}

.related-articles-message {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
  font-size: 0.875rem;
  line-height: 1.6;
  overflow: hidden;
  padding-top: 16px;
  padding-bottom: 16px;
  position: relative;
  width: 100%;

  box-shadow:
    0 0 0 0 var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
    0 0 0 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
    0 0 0 0 var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0 0 thin 0;
}
</style>
